import { ActivateUserRequest, ActivateUserResponse, ChangeUserPasswordRequest, ChangeUserPasswordResponse } from "../../../../interfaces/fetch/admin"
import { useFetchAdapter } from "../../useFetchAdapter"



export const useAdminUsersFetch = () => {

    const { postRequest } = useFetchAdapter()

    const activateUserService = async ( data : ActivateUserRequest) => {
        
        let result : ActivateUserResponse = {
            success : false,
            data : null,
            message : ""
        }

        const urlPath = `/api/admin/users/activate-user` 

        result = await postRequest(urlPath , data)

        return result
    }

    const changeUserPasswordService = async ( data : ChangeUserPasswordRequest) => {

        let result : ChangeUserPasswordResponse = {
            success : false,
            data : null,
            message : ""
        }

        const urlPath = `/api/admin/users/change-password`

        result = await postRequest(urlPath , data)

        return result
    }



    return {
        activateUserService,
        changeUserPasswordService
    }
}